// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4037) return "static/chunks/4037.d823e7b65053f0c8.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"7340":"035a17e4dd3df7dc","9313":"ee528f55e8aba51a"}[chunkId] + ".js";
};